import React, { FC, useMemo } from "react";
import { Empty, Table as _Table } from "antd";
import { SchemaItem, TableView } from "@data-root/types";
import {
  InlineMultipleRowsProps,
  View,
  useAppContext,
  useInlineContext,
  withGroups,
  CustomButton,
  ActionBar,
} from "@data-root/react";

interface Props {
  fields?: string[];
}

export const Table: FC<InlineMultipleRowsProps & Props> = withGroups(
  ({ getContext, rows, fields, onFetch }) => {
    const { styles } = useAppContext();
    const { table, view } = useInlineContext();
    const { options } = view as TableView;

    const itemsMap = useMemo(
      () =>
        table.items.reduce(
          (acc, item) => {
            acc[item.id] = item;
            return acc;
          },
          {} as Record<string, SchemaItem>
        ),
      [table]
    );

    const columns = useMemo(() => {
      const columns = [];

      if (fields)
        columns.push(
          ...fields.map((field) => ({
            key: field,
            dataIndex: `$${field}`,
            title: itemsMap[field].name,
          }))
        );
      else
        columns.push(
          ...table.items.map((item) => ({
            key: item.id,
            dataIndex: `$${item.id}`,
            title: itemsMap[item.id].name,
          }))
        );

      columns.push({
        title: "Acciones",
        key: "action",
        fixed: "right",
        width: 100,
        render: (text, record, index) => {
          const getExtendedContext = () => ({
            ...getContext(),
            row: record,
            rowId: record.id,
          });

          return (
            <ActionBar
              // tableId={tableId}
              // rowId={record.id}
              // row={record}
              getContext={getExtendedContext}
              actionIds={options.actionIds}
            />
          );
        },
      });

      return columns;
    }, [fields, table.items, itemsMap, getContext, options.actionIds]);

    if (rows.length === 0)
      return (
        <View style={{ height: "100%" }}>
          <Empty style={{ margin: "auto" }} />
        </View>
      );

    return (
      <_Table
        sticky
        columns={columns}
        dataSource={rows}
        rowKey={(row) => row.id}
        pagination={false}
        scroll={{ x: 1000 }}
        footer={() => (
          <CustomButton
            type="link"
            onClick={onFetch}
            style={{
              color: styles.primaryColor,
            }}
          >
            Cargar más
          </CustomButton>
        )}
      />
    );
  }
);
